import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useLangPrefix from '../../hooks/useLangPrefix';
import './ExpatSection.css';

function ExpatSection() {
  const { t } = useTranslation();
  const langPrefix = useLangPrefix();
  const cards = t('expats.cards', { returnObjects: true });

  return (
    <section className="py-5 py-lg-6 bg-navy text-white" id="expats">
      <div className="container">
        <div className="row justify-content-center mb-4 mb-lg-5">
          <div className="col-lg-8 text-center">
            <h2 className="h3 fw-semibold mb-2">{t('expats.heading')}</h2>
            <p className="text-white-50 mb-0">{t('expats.intro')}</p>
          </div>
        </div>
        <div className="row g-3 g-md-4 justify-content-center">
          {Array.isArray(cards) &&
            cards.map((card, i) => (
              <div className="col-6 col-lg-3" key={i}>
                <Link to={`${langPrefix}${card.link}`} className="text-decoration-none">
                  <div className="expat-card h-100 text-center p-3 p-md-4 rounded-3">
                    <span className="fw-semibold text-white">{card.title}</span>
                  </div>
                </Link>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}

export default ExpatSection;
